import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import aos from '@src/utils/aos';
import { observable } from 'mobx';
import request from '@src/utils/request';

import { useRouteMatch } from 'react-router-dom';
import $$tracker from '@src/tracker';
class JobArticleStore extends BaseStore {
  @observable jobList = [];

  @observable jobInfo = {};

  @observable pageConfig = {};

  /**
   * 招聘模式 social：社招 campus：校招
   */
  @observable mode = 'social';
  /**
   * 组织ID
   */
  // @observable orgId = 'xishanju-test';

  @observable prior;

  /**
   * 将地点数组格式化为字符串。
   * @param {Array} arr - 地点数组，其中每个元素都是一个包含城市名称的对象。
   * @returns {string} - 格式化后的字符串，城市名称之间用逗号分隔，最后一个逗号被去除。
   */
  formatLocations(arr) {
    let str = '';
    arr.forEach(item => {
      str += `${item.city},`;
    });
    if (str.length > 0) {
      str = str.slice(0, -1);
    }
    return str;
  }

  init() {
    let { jobId, prior } = this.$routeMatch.query;

    if (jobId) {
      // let jobList = JSON.parse(window.localStorage.getItem('jobList'));
      // if (jobList) {
      //   this.jobList = jobList.filter(item => item.id !== jobId);
      // }
      this.prior = prior;
      this.getJobDetails(jobId);
    } else {
      // this.redirect('/jobList');
    }
  }

  /**
   * 检索职位列表。
   * @param {string} zhinengId - 地区id
   * @returns {Promise<void>}
   */
  getJobDetails(jobId) {
    return request
      .get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs/${this.orgId}/${jobId}`, {})
      .then(res => {
        // console.log(res, 'jobInfo');
        this.jobInfo = res;
        this.getJobList(this.jobInfo.zhineng.id, jobId);
      })
      .catch(error => {
        console.error('GET 请求失败', error);
      });
  }
  /**
   * 点击查看职位列表
   */
  onApplyClick() {
    $$tracker.clickTdjl();
    let { jobId, prior } = this.$routeMatch.query;

    // let loginStatus = !!window.XPASS.u_account;
    let loginStatus = !!window.userAccount;
    if (!loginStatus) {
      window.XPASS.signin();
      return;
    }

    if (DEPLOY_ENV === 'master' || DEPLOY_ENV === 'test') {
      const url = this.mode === 'social' ? 'apply.html' : 'campusApply.html';
      this.jumpPage(url, `#/?jobId=${jobId}&prior=${prior}`);
    } else {
      this.redirect(`apply?jobId=${jobId}&prior=${prior}`);
    }
  }

  clickJob(item) {
    if (DEPLOY_ENV === 'master' || DEPLOY_ENV === 'test') {
      const url = this.mode === 'social' ? 'jobArticle.html' : 'campusArticle.html';
      this.jumpPage(url, `#/?jobId=${item.id}&prior=${item.prior}`, true);
    } else {
      // const url = this.mode === 'social' ? 'jobArticle.html' : 'campusArticle.html';
      // this.jumpPage(url, `#/?jobId=${item.id}&prior=${item.prior}`, true);
      this.redirect(`jobArticle?jobId=${item.id}&prior=${item.prior}`);
      // const url = this.mode === 'social' ? 'jobArticle.html' : 'campusArticle.html';
      // this.jumpPage(url, `#/?jobId=${item.id}&prior=${item.prior}`);
    }
    // reload();
  }

  // getJobList(zhinengId, jobId) {
  //   const queryParams = {
  //     mode: this.mode,
  //     // zhinengId: zhinengId,
  //     limit: 9999
  //   };
  //   return request
  //     .get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs/${this.orgId}`, {
  //       ...queryParams
  //     })
  //     .then(res => {
  //       if (res.jobs.length > 0) {
  //         this.jobList = res.jobs.filter(item => item.id !== jobId);
  //       }
  //     })
  //     .catch(error => {
  //       console.error('GET 请求失败', error);
  //     });
  // }
  getJobList(zhinengId, jobId) {
    const allJobs = []; // 用于存储所有的工作数据
    let total = 0; // 初始化总数据量

    // 定义一个递归函数来处理分页请求
    const fetchJobs = offset => {
      const queryParams = {
        mode: this.mode,
        offset: offset,
        limit: 100 // limit 只支持 100
        // zhinengId: zhinengId,
      };

      return request
        .get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs/${this.orgId}`, {
          ...queryParams
        })
        .then(res => {
          total = res.total; // 更新总数据量
          allJobs.push(...res.jobs); // 将当前请求的工作数据添加到 allJobs 数组中

          // 如果已经获取到所有数据，则停止递归
          if (allJobs.length >= total) {
            // 过滤掉 id 等于 jobId 的数据
            this.jobList = allJobs.filter(item => item.id !== jobId);
            return;
          }

          // 否则，继续下一页的请求
          return fetchJobs(offset + 100);
        })
        .catch(error => {
          console.error('GET 请求失败', error);
        });
    };

    // 从第一页开始请求
    return fetchJobs(0);
  }
  use() {
    super.use();
    this.$routeMatch = useRouteMatch();
    useMount(async () => {
      aos.reInit();
      $$tracker.loadPageXqjz();

      // console.log(window.sessionStorage.getItem('jobList'));
      // window.FUN_LINK_SDK.getPageData().then(res => {
      //   const { data, status } = res;
      //   // console.log('data', data);
      //   this.pageConfig = data.pageConfig;
      //   this.orgId = data.pageConfig.orgId;
      //   // this.orgId = 'seasungames';
      //   this.init();
      // });

      window.__FUN_LINK_PAGE_DATA_PROMISE__.then(res => {
        const { data, status } = res;

        // console.log(data);
        this.pageConfig = data.pageConfig;
        this.mode = data.modeConfig.mode;
        this.init();
      });

      // console.log('componentDidMount');
    });
  }
}

export default JobArticleStore;
